



import { toast } from "react-toastify";
import CustomTable from "../../../components/customTable/CustomTable";
import { Box, IconButton, Tooltip } from "@mui/material";
import { ContentCopy } from "@mui/icons-material";
import { createMRTColumnHelper } from "material-react-table";
import ToastComponent from "../../../components/customTable/ToastComponent";
import { useDispatch, useSelector } from "react-redux";
import { useCallback, useEffect, useState } from "react";
import { complianceReportApi } from "../../../app/slices/reports/complianceReportSlice";
import NameDateSearchComponent from "../../../components/customTable/NameDateSearchComponent";

export default function ComplianceReport() {
  const dispatch = useDispatch();

  const sliceResponse = useSelector((state) => state.complianceReport.complianceReport.data);
  const stateLoading = useSelector(
    (state) => state.complianceReport.loading
  );
  const [queryParams, setQueryParams] = useState({
    startDate: null,
    endDate: null,
  });

  // Memoized function to dispatch the API call with the necessary parameters
  const fetchData = useCallback(() => {
    let params = {};
    params.name = queryParams.customerName;
    params.startDate = queryParams.startDate;
    params.endDate = queryParams.endDate;
    if (Object.keys(params).length > 0) {
      dispatch(complianceReportApi(params)); // Dispatch API call even when reset (empty search term or date)
    }
  }, [dispatch, queryParams]);

  useEffect(() => {
    fetchData();
  }, [fetchData]);

  const handleSearchByDate = (startDate, endDate, customerName) => {
    setQueryParams({ startDate, endDate, customerName });
  };

  const columnHelper = createMRTColumnHelper();
  const columns = [
    columnHelper.accessor("_id", {
      header: "ID",
      size: 30,
      Cell: ({ cell }) => {
        const handleCopy = () => {
          navigator.clipboard.writeText(cell.row?.original?._id);
          toast.success("Copied to clipboard!");
        };
        return (
          <Tooltip title={cell.row?.original?._id}>
            <IconButton onClick={handleCopy}>
              <ContentCopy />
            </IconButton>
          </Tooltip>
        );
      },
    }),
    columnHelper.accessor("name", {
      header: "Name",
      size: 30,
      Cell: ({ cell }) => <div style={{ textAlign: "center" }}>{cell.row.original?.name || "N/A"}</div>,
    }),
    columnHelper.accessor("mobileNo", {
      header: "Mobile No",
      size: 30,
      Cell: ({ cell }) => <div>{cell.row.original?.mobileNo || "N/A"}</div>,
    }),
    columnHelper.accessor("Email", {
      header: "Email",
      size: 30,
      Cell: ({ cell }) => <div>{cell.row.original?.Email || "N/A"}</div>,
    }),
    columnHelper.accessor("partner_id", {
      header: "Partner ID",
      size: 30,
      Cell: ({ cell }) => {
        const handleCopy = () => {
          navigator.clipboard.writeText(cell.row?.original?.partner_id || "");
          toast.success("Copied to clipboard!");
        };
        return (<>
          <Tooltip title={cell.row?.original?.partner_id || "N/A"}>
            <IconButton onClick={handleCopy}>
              <ContentCopy />
            </IconButton>
          </Tooltip>
          {cell.row?.original?.partner_id || "N/A"}
        </>
        );
      },
    }),
    columnHelper.accessor("partner_username", {
      header: "Partner Username",
      size: 30,
      Cell: ({ cell }) => <div>{cell.row.original?.partner_username || "N/A"}</div>,
    }),
    columnHelper.accessor("address", {
      header: "Address",
      size: 30,
      Cell: ({ cell }) => <div>{cell.row.original?.address || "N/A"}</div>,
    }),
    columnHelper.accessor("flag", {
      header: "Flag",
      size: 30,
      Cell: ({ cell }) => <div>{cell.row.original?.flag || "N/A"}</div>,
    }),
    columnHelper.accessor("bank", {
      header: "Bank",
      size: 30,
      Cell: ({ cell }) => <div>{cell.row.original?.bank || "N/A"}</div>,
    }),

    columnHelper.accessor("pan", {
      header: "PAN",
      size: 30,
      Cell: ({ cell }) => <div>{cell.row.original?.pan || "N/A"}</div>,
    }),

    columnHelper.accessor("createdAt", {
      header: "Created At",
      size: 30,
      Cell: ({ cell }) => (
        <div>
          {cell.row.original?.createdAt
            ? new Date(cell.row.original.createdAt).toLocaleDateString()
            : "N/A"}
        </div>
      ),
    }),
    columnHelper.accessor("updatedAt", {
      header: "Updated At",
      size: 30,
      Cell: ({ cell }) => (
        <div>
          {cell.row.original?.updatedAt
            ? new Date(cell.row.original.updatedAt).toLocaleDateString()
            : "N/A"}
        </div>
      ),
    }),
  ];


  return (
    <>   
      {/*  */}
      <NameDateSearchComponent onSearch={handleSearchByDate} />
      <Box mt={2}>

        <CustomTable columns={columns} data={sliceResponse}
          loading={stateLoading}
          permissionKey="ComplianceReport"
        />
      </Box>
    </>
  )
}
